import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CategoryFilter ProductCategory-filter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "CategoryFilter" }, "Filtr produktů", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Zrušit filtr", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSection = _resolveComponent("FilterSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.changedSlides.length || _ctx.selectedChecks.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter(null))),
          class: "CategoryFilter-reset",
          type: "button"
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.filter.sections, (filterSection) => {
      return (_openBlock(), _createBlock(_component_FilterSection, {
        key: filterSection.name,
        section: filterSection
      }, null, 8, ["section"]))
    }), 128))
  ]))
}